const approachStyles = (theme) => ({
  bold: { fontWeight: 700 },
});

export default approachStyles;
